import { CardCloseButton, CardHeader, CardTitle } from "@components/ui/card";
import { useMoveFolderCtx } from "../ctx";

export const MoveFolderHeader = () => {
  const { loading, folderData, folderName, closeDialog } = useMoveFolderCtx();

  const displayName = folderData?.name || folderName || "Folder";

  return (
    <CardHeader className="tw-flex tw-items-center tw-justify-between">
      <CardTitle>Move "{displayName}"</CardTitle>
      <CardCloseButton
        onClick={() => {
          if (loading) return;
          closeDialog();
        }}
      />
    </CardHeader>
  );
};
